/* eslint-disable react/prop-types */
import React from "react";
import PropTypes from "prop-types"; // Importing PropTypes
import SEOHead from "./SEOHead";
import { Box } from "@mui/material";
import NavBarSection from "../navBar";
import siteData from "../../../../_data";
const { brand } = siteData;

const HeaderSection = ({
  title = brand?.name,
  description = brand?.description,
}) => {
  return (
    <>
      <SEOHead title={title} description={description} />
      <Box
        component="header"
        id="site-header-section"
        style={{
          position: "relative",
          padding: "0px",
          margin: "0px",
          boxSizing: "border-box",
          width: "100%",
          overflowX: "hidden",
        }}
      >
        <span id="back-to-top-anchor" />
        <NavBarSection />
      </Box>
    </>
  );
};

// Defining prop types
HeaderSection.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
};

export default HeaderSection;
